import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HexGridComponent from './HexGridComponent';

const OurTeam = () => {
  return (
    <div className=' bg-gradient-to-b from-[#2D1735] to-[#5f40a1] '>
      <Header />
      <div className="container mx-auto px-2 py-8 ">

        <HexGridComponent />
      </div>
      <Footer />
    </div>
  );
};

export default OurTeam;